import { PXE_BACKEND_URL } from '@packages/shared-ui/constants';
import getEnv, { Environment } from '@/utils/environment';

const env: Environment = getEnv();

type campId = {
  [index in Environment]: string;
};

export type GoogleUrls = {
  [index in Environment]: string;
};

const campIds: campId = {
  [Environment.LOCAL]: '94B20FB00E62A732',
  [Environment.DEVMAJ]: '94B20FB00E62A732',
  [Environment.MAJSTG]: '94B20FB00E62A732',
  [Environment.PROD]: 'SR4802',
};

export const CAMP_ID = campIds[env];

const SUNRUN_URLS_BY_ENV = {
  [Environment.LOCAL]: 'https://devmaj-www.sunrundev.com',
  [Environment.DEVMAJ]: 'https://devmaj-www.sunrundev.com',
  [Environment.MAJSTG]: 'https://majstg-www.sunrun.com',
  [Environment.PROD]: 'https://www.sunrun.com',
};

export const SUNRUN_URL = SUNRUN_URLS_BY_ENV[env];

export function getBaseUrlByEnv(): string {
  return SUNRUN_URLS_BY_ENV[env];
}

export const MYSUNRUN_URL = {
  [Environment.LOCAL]: 'https://majstg-my.sunrun.com/login',
  [Environment.DEVMAJ]: 'https://majstg-my.sunrun.com/login',
  [Environment.MAJSTG]: 'https://majstg-my.sunrun.com/login',
  [Environment.PROD]: 'https://my.sunrun.com/login',
};

export function getLoginUrlByEnv(): string {
  return MYSUNRUN_URL[env];
}

const PUBLIC_RETROFIT_BFF_URL = {
  [Environment.LOCAL]: PXE_BACKEND_URL[Environment.MAJSTG],
  [Environment.DEVMAJ]: PXE_BACKEND_URL[Environment.MAJSTG],
  [Environment.MAJSTG]: PXE_BACKEND_URL[Environment.MAJSTG],
  [Environment.PROD]: PXE_BACKEND_URL[Environment.PROD],
} as const;

export const PUBLIC_RETROFIT_PROPOSAL_URL = `${PUBLIC_RETROFIT_BFF_URL[env]}/retrofit-proposal`;

export const BATTERY_PRODUCTS_PUBLIC_URL = `${PUBLIC_RETROFIT_BFF_URL[env]}/products/battery`;

export const ELIGIBILITY_URL = `${PUBLIC_RETROFIT_BFF_URL[env]}/retrofit-eligibility`;

export const SYSTEM_OVERVIEWS_URL = `${PXE_BACKEND_URL[env]}/system-overviews`;

export const NEARBY_CUSTOMERS_URL = `${PXE_BACKEND_URL[env]}/nearby-customers`;

export const SERVICE_TERRITORY_URL = `${PXE_BACKEND_URL[env]}/service-territory`;

export const GET_MARKET_URL = `${PXE_BACKEND_URL[env]}/market`;

export const STOREFRONT_URL = {
  PROD: '0prqvu-0y.myshopify.com',
  DEV: 'pxe-dev-sandbox.myshopify.com',
};

export const QUOTE_URL = `${PXE_BACKEND_URL[env]}/quote`;

export const FIND_LEAD_URL = `${PXE_BACKEND_URL[env]}/lead`;

export const FEATURE_FLAGS_URL = `${PXE_BACKEND_URL[env]}/feature-flags`;

export const REFERRALS_REQUEST_URL = `${PXE_BACKEND_URL[env]}/referrals/request`;

export const REFERRALS_SUBMIT_URL = `${PXE_BACKEND_URL[env]}/referrals/submit`;
